export default "__VITE_ASSET__CcNGwf$v__"